import styled from '@emotion/styled';
import { Typography } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const WidgetContainer = styled.div`
  background-color: ${customPalette.accent.white};
  border-radius: 8px;
  padding: 16px;
  color: ${customPalette.accent.main};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: 100%;
  margin-right: 24px;
  max-width: 376px;

  @media (max-width: 1200px) {
    max-width: 100%;
  }
`;

export const WidgetTitle = styled(Typography)`
  font-size: 16px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.15px;
  color: ${customPalette.accent.main};
  margin-bottom: 8px;
`;

export const WidgetSubtitle = styled(Typography)`
  font-size: 14px;
  font-weight: 700;
  line-height: 120%;
  color: ${customPalette.accent.main};
  margin-bottom: 16px;
`;

export const WidgetRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
  align-items: flex-start;
`;

export const WidgetLabel = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: ${customPalette.accent.main};
  flex-grow: 1;
  white-space: normal;
  padding-right: 10px;
`;

export const WidgetValue = styled(Typography)`
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  color: ${customPalette.accent.main};
  text-align: right;
  white-space: nowrap;
`;

export const ActionButtonContainer = styled.div`
  margin-top: auto;
  margin-bottom: 0;
  padding-top: 12px;
`;
